/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.directive('comunity', function ($http, $q, $timeout) {
	return {
		restrict: 'E',
		scope: {
			tModel: '=',
			tCounty: '=',
			tState: '='
		},
		templateUrl: "/assets/js/angular/components/directives/teryt/types/comunity.html",
		link: function (scope) {
			scope.comunities = {
				list: [],
				item: null,
				text: null
			};

			scope.required = typeof scope.tModel.required == 'undefined'?false:scope.tModel.required;

			scope.disabled = true;
			scope.$watch('tCounty', function () {
				scope.disabled = true;
				scope.comunities.list = [];
				scope.comunities.text = null;
				if (!_.isNull(scope.tCounty) && !_.isNull(scope.tCounty.name) && scope.tCounty.name != '') {
					scope.disabled = false;
				}
			}, true);


			$timeout(function () {
				if (!_.isNull(scope.tModel)) {
					scope.comunities.text = scope.tModel.name;
					if (!_.isUndefined(scope.tModel.disabled)) {
						scope.disabled = scope.tModel.disabled;
					}
				}
			}, 200);


			scope.comunitySearch = function (query) {
				var deferred = $q.defer();
				var post = {name: query};
				if (!_.isUndefined(scope.tCounty) && !_.isNull(scope.tCounty)) {
					post.county_id = scope.tCounty.county_id;
				}
				if (!_.isUndefined(scope.tState) && !_.isNull(scope.tState) && scope.tState!="") {
					post.state = scope.tState;
				}
				$http.post('/teryt/comunity', post)
					.success(function (list) {
						scope.comunities.list = list;
						deferred.resolve(scope.comunities.list.filter(scope.createFilterFor(query)));
					});

				return deferred.promise;
			};

			scope.createFilterFor = function (query) {
				return function filterFn(item) {
					return (angular.lowercase(item.name).indexOf(angular.lowercase(query)) === 0);
				};
			};
		}
	};
});
